<template>

  <div id="obra">

    <header class="secondary-header">
      <div class="cont">
        <h1>
        	<router-link v-bind:to="'/'">
        		<span class="verde-span">Pensamientos</span> latinoamericanos
          </router-link>
        </h1>

        <transition name="fade" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
            <p v-if="autor">Autores / {{ fullName }} / Obra</p>
        </transition>

      </div>
    </header>


    <!-- Loading -->
    <div class="loading" v-if="loading">
      <div class="loader"></div>
    </div>


    <transition name="fade" enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown" mode="out-in">

        <main v-if="obra" class="cont">
        	<header class="autor-header-aside verde">
                <router-link :to="{ name: 'autor', params: { id: autor.id }}" class="back-link">
                    <div :style="autorImg(this.autor.img)" class="autor-img"></div>
                	<h2>{{ this.autor.nombre}} <span class="accent">{{ this.autor.apellido }}</span></h2>
                </router-link>

                <transition name="fade" enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown" mode="out-in">

                  <div v-if="obra" class="libro-item verde">

                      <img :src="imgRoute(obra.portada)" :alt="obra.titulo" v-if="obra.portada">

                      <div class="obra-details">
                          <h3>{{ obra.titulo }} <span class="light">{{ obra.publicado }}</span></h3>
                          <small v-html="obraDetalles"></small>
                      </div>

                      <button @click="verIndice" v-if="indiceCount" class="btn btn-verde">Ver &iacute;ndice</button>

                  </div>

                </transition>

        	</header>

        	<section class="obra-content">

        		<div class="obra-cita verde" v-for="texto in textos">

              <transition name="fade" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
        			   <p v-if="texto" v-html="textual(texto)"></p>
              </transition>

        		</div>

        	</section>


        </main>

    </transition>


    <transition name="fade" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">

      <div class="modal" v-if="indiceCount" v-show="indice">
        <button class="modal-close" @click="closeModal">X</button>

        <div class="slider-wrapper">

          <!-- buttons -->
          <button id="sliderPrevious" class="slider-btn">&larr;</button>
          <button id="sliderNext" class="slider-btn">&rarr;</button>

          <ul id="slider" class="my-slider" v-if="autor">
            <li v-for="n in indiceCount">
              <img :src="indiceRoute(n)" :alt="obra.titulo">
            </li>
          </ul>

        </div>

        <h4>{{ obra.titulo }}</h4>
      </div>

    </transition>

  </div>
</template>



<script>
// Import slider
import slider from "ga-basic-slider/dist/ga-basic-slider-1.0.0-min.js";

export default {
  name: 'obra',

  data (){
    return {
      autor: false,
      carpeta: false,
      detalles: false,
      error: null,
      indice: false,
      indiceCount: false,
      loading: false,
      obra: false,
      params: false,
      slider: false,
      textos: false

    }
  },

  created (){
    this.fetchData();
  },

  computed: {
    fullName: function (){
      return this.autor.nombre + ' ' + this.autor.apellido;
    },

    obraDetalles: function(){
        this.detalles = this.obra.editorial + ', ';

        if(this.obra.ed_num){
          this.detalles += this.obra.ed_num + '<br>';
        }

        if(this.obra.indices){
          this.detalles += this.obra.detalles;

        }else{
          this.detalles += '<br><br><h4>Palabras Clave</h4>' +this.obra.detalles;

        }


        return this.detalles;
    }



  },

  updated () {
     //  load slider
    this.$nextTick(function () {

      if (this.indice) {

        console.log('load slider');

        this.params = {
          slider: document.getElementById('slider'),
          btnNext: document.getElementById('sliderNext'), // Next
          btnPrevious: document.getElementById('sliderPrevious'), // Previous
        };

        this.slider = new gaBasicSlider(this.params);
        
      }

    });



  },

  watch: {
    '$route' : 'fetchData'
  },

  methods: {
    fetchData (){
      this.error = this.textos = null;
      this.loading = true;


      this.$http.get('/api/textuales.php', { params: {id: this.$route.params.obra }}).then( function(response) {
      // this.$http.get('http://temp1.unla.edu.ar/penslat-build/api/textuales.php', { params: {id: this.$route.params.obra }}).then( function(response) {

          this.loading = false;
          this.textos = response.data;
          this.obra = this.textos[0];

          if(this.obra.indices) {

            this.indiceCount = (JSON.parse(this.obra.indices)).length;

          }


          //  load slider
          /* this.$nextTick(function () {

            console.log('load slider');

            this.params = {
              slider: document.getElementById('slider'),
              btnNext: document.getElementById('sliderNext'), // Next
              btnPrevious: document.getElementById('sliderPrevious'), // Previous
            };

            this.slider = new gaBasicSlider(this.params);
          }); */


      }, function(response) {
          console.log('Error: no se recibieron los textos');
      });

      this.loading = true;

      this.$http.get('/api/autor.php', { params: {id: this.$route.params.autor }}).then( function(response) {
      // this.$http.get('http://temp1.unla.edu.ar/penslat-build/api/autor.php', { params: {id: this.$route.params.autor }}).then( function(response) {

          this.autor = response.data;

          this.carpeta = this.autor.apellido.toLowerCase();
          this.carpeta = this.carpeta.replace(/\ /g, '-');


      }, function(response) {
          console.log('Error: no se recibió el autor');
      });

    },

    imgRoute (portada){
      return '/static/img/obras/' +  portada;
      // return 'static/img/obras/' +  portada;
    },

    verIndice(){
      this.indice = true;
    },

    textual(texto){
      return texto.extracto + '<br><small class="txt-small">' +  texto.ref + '</small>';
    },

    autorImg (img){
      return 'background-image: url("/static/img/autores/'+ img +'");';
      // return 'background-image: url("static/img/autores/'+ img +'");';
    },

    indiceRoute (n){
      return '/static/img/obras/' + JSON.parse(this.obra.indices)[n-1];
      // return 'static/img/obras/' + JSON.parse(this.obra.indices)[n-1];

    },


    closeModal(){
      this.indice = false;
    }




  }
}


</script>


// WEBPACK FOOTER //
// src/components/Obra.vue